export default __webpack_public_path__ + "static/media/zonta_small.2abb279b.jpg";